module.exports = __webpack_public_path__ + "img/ARCH_07_prew.72a1b74d.jpg";